<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../../assets/images/return.png"><span>维修耗材出库</span><img src="../../../assets/images/material-add.png">
    </div>
    <div class="common search-box">
      <input type="text" placeholder="请输入物品名称/条码">
    </div>
    <div class="date-wrapper common">
      <span class="title">日期</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday1(date_time1)">
        <div @click="selectData1">{{date_time1}}</div>
        <mt-datetime-picker ref="datePicker1" type="date" v-model="pickerValue1" @confirm="handleConfirm1"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday1(date_time1)">
      </span>
      <span class="division">至</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday2(date_time2)">
        <div @click="selectData2">{{date_time2}}</div>
        <mt-datetime-picker ref="datePicker2" type="date" v-model="pickerValue2" @confirm="handleConfirm2"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday2(date_time2)">
      </span>
    </div>
    <div class="common order-wrapper">
      <div class="block">
        <div class="item">
          <span class="total">合计</span>
          <input type="checkbox" id="w_total" :checked="checkedAll == true" @click="isCheckedAll(checkedAll)">
          <label for="w_total" style="background-position: 50px 9px;"><span style="padding-left: 70px;">全选</span></label>
          <div><span>100</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_norecorded" :checked="checkeds.indexOf(1) >= 0" @click="isChecked(1)">
          <label for="w_norecorded"><span>未入账</span></label>
          <div><span class="orange">100</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_recorded" :checked="checkeds.indexOf(2) >= 0" @click="isChecked(2)">
          <label for="w_recorded"><span>已入账</span></label>
          <div><span class="green">100</span>笔</div>
        </div>
      </div>
    </div>
    <div class="common orderlist-wrapper">
      <div class="layout mar_bot">
        <div class="flex-1 describe"><span>维修耗材出库：200927-001</span>杨正亚</div>
        <div class="date">2020-12-01</div>
      </div>
      <div class="layout">
        <div class="flex-1">件数120</div>
        <div class="status background_red">未入账</div>
      </div>
    </div>
    <div class="common orderlist-wrapper">
      <div class="layout mar_bot">
        <div class="flex-1 describe"><span>维修耗材出库：200927-001</span>杨正亚</div>
        <div class="date">2020-12-01</div>
      </div>
      <div class="layout">
        <div class="flex-1">件数120</div>
        <div class="status background_green">已入账</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WarehouseOut',
  metaInfo: {
    title: '物资管理'
  },
  data () {
    return {
      date_time1: '',
      date_time2: '',
      pickerValue1: new Date(),
      pickerValue2: new Date(),
      checkedAll: true, // 默认全选状态
      checkeds: [1, 2],
      allcheckeds: [1, 2]
    }
  },
  created () {
    this.date_time1 = this.getDate()
    this.date_time2 = this.getDate()
  },
  methods: {
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      return `${year}-${month}-${day}`
    },
    // 打开时间选择器
    selectData1 () {
      this.$refs['datePicker1'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 打开时间选择器
    selectData2 () {
      this.$refs['datePicker2'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 选择时间点击确定按钮
    handleConfirm1 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time1 = resDate
    },
    // 选择时间点击确定按钮
    handleConfirm2 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time2 = resDate
    },
    // 上一个天
    lastday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    // 上一个天
    lastday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    // 是否全选
    isAllCheckeds: function () {
      if (this.checkeds.length === this.allcheckeds.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    // 全选
    isCheckedAll (checkedAll) {
      if (checkedAll === true) {
        this.checkedAll = false
        this.checkeds = []
      } else {
        this.checkedAll = true
        this.checkeds = [1, 2]
      }
    },
    isChecked (checkedId) {
      let Index = this.checkeds.indexOf(checkedId)
      if (Index >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.checkeds.splice(Index, 1)
      } else {
        // 选中该checkbox
        this.checkeds.push(checkedId)
      }
      console.log(this.checkeds)
      this.isAllCheckeds() // 是否全选
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.date-wrapper {
  font-size: 15px;
  color: #000000;
}
.date-wrapper .title {
  padding-right: 10px;
}
.date-wrapper .division {
  padding: 0 5px;
}
.date-wrapper span {
  line-height: 18px;
}
.date-wrapper img {
  width: 18px;
  height: 18px;
  vertical-align: top;
}
.date-wrapper div {
  display: inline-block;
  padding: 0 2px;
}
.order-wrapper {
  display: flex;
  font-size: 14px;
}
.order-wrapper .block {
  flex: 1;
}
.order-wrapper .block .item {
  margin: 0 4px;
  background-color: #f4f4f4;
  position: relative;
  padding: 0 5px;
}
.order-wrapper .block .item input {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
}
.order-wrapper .block .item input:checked+label {
  background-image: url(../../../assets/images/checked.png);
}
.order-wrapper .block .item label {
  background-repeat: no-repeat;
  background-image: url(../../../assets/images/unchecked.png);
  background-position: 5px 9px;
  background-size: 16px 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.order-wrapper .block .item label span:last-child {
  padding: 7px 0 0 26px;
  display: block;
}
.order-wrapper .block .item div {
  padding: 30px 0 5px 0;
}
.order-wrapper .block .item div span {
  font-size: 17px;
  font-weight: 700;
  padding-right: 4px;
}
.order-wrapper .block .item .total {
  position: absolute;
  top: 7px;
  left: 5px;
}
.orderlist-wrapper {
  font-size: 15px;
  color: #313131;
}
.orderlist-wrapper .layout {
  display: flex;
}
.orderlist-wrapper .layout .flex-1 {
  flex: 1;
}
.orderlist-wrapper .layout .describe span {
  font-weight: 700;
  padding-right: 15px;
}
.orderlist-wrapper .layout .date {
  color: #8c8c8c;
}
.orderlist-wrapper .layout .status {
  color: #fff;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 14px;
  display: inline-block;
}
.mar_bot {
  margin-bottom: 8px;
}
.background_green {
  background-color: #35c53b;
}
.background_red {
  background-color: #ff5148;
}
.green {
  color: #35c53b;
}
.orange {
  color: #fa6b2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/WarehouseOut/WarehouseOut.vue